<template>
<div>
    <CCol sm="12">
        <CCard>
            <CCardBody class="d-flex flex-column">
                <div class="d-flex mb-2 justify-content-end align-items-start">
                    <!-- Language dropdown -->
                    <LanguageDropdown v-model="currentLanguage"></LanguageDropdown>
                </div>
                <div class="d-flex flex-column">
                    <!-- Key -->
                    <div role="group" class="form-group col-12">
                        <label class=""> {{ $t('keyMandatory') }}</label>
                        <CInput type="text" v-model="keyValuePair.key" :invalid-feedback="errorOutput['Key']" :is-valid="genericValidator(keyValuePair.key, attemptedSubmit) && errorValidator('Key')"></CInput>
                    </div>                        
                    <!-- Values -->
                    <div role="group" class="form-group col-12 mb-0">
                        <label class=""> {{ $t('descriptionMandatory') }}</label>
                        <vue-editor v-model="keyValuePair.values[currentLanguage.key]" v-bind:class="{'is-invalid': genericValidator(keyValuePair.values, attemptedSubmit) == false || errorValidator(keyValuePair.values) }"></vue-editor>
                        <div v-if="errorOutput.Values" class="invalid-feedback">{{errorOutput.Values}}</div>
                    </div>
                </div>
                <!-- Action button + submitting -->  
                <div role="group" class="form-group col-12 d-flex justify-content-end my-3">
                    <CSpinner v-if="submitting" variant="success" small class="align-self-end"></CSpinner>
                    <CButton v-else type="button" class="btn btn-primary" @click="submitClicked">{{ $t('acceptChanges') }}</CButton>
                </div>
                <!-- Loading -->
                <FormLoading v-if="loading"></FormLoading>
            </CCardBody>
        </CCard>
    </CCol>
    <ConfirmationPopUp :confirmationMessage="confirmationMessage" @closeConfirmRequested="onClickConfirmationPopup" v-model="showConfirmationPopup"></ConfirmationPopUp>
</div>
</template>
 
<script>
import { genericValidator, errorValidator, deepClone } from "@/helpers/utils.js";
import KeyValuePair from "@/classes/KeyValuePair";
import { mapState, mapActions } from 'vuex'
import LanguageDropdown from "@/controls/LanguageDropdown.vue";
import { CONSTANTS } from '@/helpers/consts';
import ConfirmationPopUp from "@/controls/popups/ConfirmationPopUp.vue";
import FormLoading from '@/controls/FormLoading.vue'
import { VueEditor } from "vue2-editor";

  export default {
  components: { LanguageDropdown, ConfirmationPopUp, FormLoading, VueEditor },
    props:{    
        baseKeyValuePair:
        {
            type: Object,
            default: null,
        },
        loading:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            attemptedSubmit: false,
            currentLanguage: CONSTANTS.supportedLanguages[0],
            keyValuePair: new KeyValuePair('', {}),
            submitting: false,
            showConfirmationPopup: false,
            confirmationMessage:"",
        }
    },
    mounted: function()
    {
        this.resetKeyValuePair();
    },
    computed:
    {
        ...mapState({ 
            alertType: state => state.alert.type,
            alertOutput: state => state.alert.output
        }),
        errorOutput: function()
        {
            var result = [];

            if(this.alertType == 'alert-danger' && this.alertOutput && Array.isArray(this.alertOutput))
            {
                result = this.alertOutput.reduce(function(accum, currentVal) {
                accum[currentVal.key] = currentVal.value;
                    return accum;
                }, {});
            }

            // Validate required fields
            if(!this.keyValuePair.key) { result['Key'] = this.$i18n.t("validateRequiredField"); }
            for (const [key, value] of Object.entries(this.keyValuePair.values)) { if(!value) { result['Values'] = this.$i18n.t("validateBothTranslations"); break; }; }

            return result;
        },
        ...mapState('keyValues', ['putKeyValueOutput']),
        ...mapState('keyValues', ['postKeyValueOutput']),
    },
    methods:{
        resetKeyValuePair(){
            if(!this.baseKeyValuePair)
            {
                var values = {}; 
                CONSTANTS.supportedLanguages.forEach(language => { values[language.key] = ""; });

                this.keyValuePair = new KeyValuePair('', values);
            }
            else
            {
                this.keyValuePair = deepClone(new KeyValuePair, this.baseKeyValuePair);          
            }
        },
        submitClicked(){
            this.attemptedSubmit = true;
            // Emit event
            if(this.keyValuePair.isValid())
            {
                this.submitting = true;
                this.$emit('submit-requested', this.keyValuePair);
            }
        },
        genericValidator,
        errorValidator,
        onClickConfirmationPopup(value){
            this.showConfirmationPopup = value;     
            this.$router.push({name: "KeyValuesList" });
        },
    },
    watch:
    {
        putKeyValueOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        postKeyValueOutput: function(val)
        {
            if(val)
            {
                this.showConfirmationPopup = true;
            }
        },
        baseKeyValuePair: function()
        {
            this.resetKeyValuePair();
        },
        alertType: function()
        {
            this.submitting = false;
        },
        alertOutput: function()
        {
            this.submitting = false;

            // Show pop up in case it is a string error
            // In case it is an array, it is shown on the field
            if(typeof this.alertOutput === 'string' || this.alertOutput instanceof String)
            {
                alert(this.alertOutput);
            }
        }
    }
  }
</script> 
 
<style scoped>

.showDropdown
{
    display: block !important;
}

.input-group-append
{
    height: fit-content;
}

img
{
    width: 50%;
    height: 50%;
}

/deep/.quillWrapper.is-invalid .ql-snow.ql-toolbar,
/deep/.quillWrapper.is-invalid .ql-snow.ql-container
{
    border-color: #e55353;
}

</style> 